import Splide from "@splidejs/splide";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Importa il CSS di AOS

document.addEventListener('DOMContentLoaded', function () {
    if ($('#article__grid').length > 0) {
        new Splide( '#article__grid', {
            perPage: 3,
            arrows: false,
            perMove: 1,
            gap: '2em',
            pagination: false,
            // rewind: true,
            // clones: 0,
            breakpoints: {
                '992': {
                    pagination: true,
                    perMove: 1,
                    perPage: 1,
                    drag: true,
                },
            },
        } ).mount();
    }

    if ($('#inmuebles__slide').length > 0) {
        new Splide( '#inmuebles__slide', {
            perPage: 2,
            arrows: false,
            perMove: 3,
            gap: '2em',
            // pagination: false,
            breakpoints: {
                '992': {
                    pagination: true,
                    perMove: 1,
                    perPage: 1,
                    drag: true,
                },
            },
        } ).mount();
    }

    if ($('#renenas__slide').length > 0) {
        new Splide( '#renenas__slide', {
            perPage: 3,
            arrows: false,
            perMove: 1,
            autoHeight: true,
            gap: '2em',
        }).mount(); 
    }

    AOS.init({
        initClassName: "aos-init",
        startEvent: "DOMContentLoaded",
    });
});
